var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"avatar"},[(_vm.loaded === 'success')?_c('img',{attrs:{"src":_vm.src,"alt":""}}):(!!_vm.name)?_c('span',{style:({ fontSize: `${_vm.fontSize}px` })},[_vm._v(_vm._s(_vm.name))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }